// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskAssignedUsersEditScreen from "../../../src/screens/task-assigned-users/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskAssignedUserEditRouteProps */

/** @typedef {Record<string, never>} TaskAssignedUserEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskAssignedUserEditRouteProps, TaskAssignedUserEditRouteState>}
 */
class TaskAssignedUserEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit assignment")}</ScreenTitle>
        <TaskAssignedUsersEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskAssignedUserEditRouteProps>} */
const TaskAssignedUserEditRouteComponent = memo(shapeComponent(TaskAssignedUserEditRoute))

export default TaskAssignedUserEditRouteComponent
